import * as types from './types';
import { getSubscriptionMetadata } from './subscriptionMetadata';
import i18n from '../../localization';

export const appStateLoadedSuccessfully = (state) => ({
  type: types.APP_STATE_LOADED_SUCCESSFULLY,
  payload: { state },
});

export const triggerModal = (flag, message) => ({
  type: types.TRANSACTION_FAILED_MODAL_TRIGGER,
  payload: { flag, message },
});

export const triggerCVVModal = (flag) => ({
  type: types.CVV_MODAL_TRIGGER,
  payload: flag,
});

export const triggerExpiryDateModal = (flag) => ({
  type: types.EXPIRY_DATE_MODAL_TRIGGER,
  payload: flag,
});

export const setAppState = (state) => {
  return async (dispatch, getState) => {
    dispatch(appStateLoadedSuccessfully(state));
    const subscriptionId = getState()?.appState?.subscriptionId;
    const signature = getState()?.appState?.signature;
    const language = getState()?.appState?.language;
    await i18n.changeLanguage(language);
    return dispatch(getSubscriptionMetadata({ subscriptionId, signature }));
  };
};
